// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import { reduxForm } from 'redux-form'
import { REQUIRED } from 'errors'
import { Search } from './components'
import { Pagination } from '../common'
import { SubmitErrors } from 'components/Form'

const Form = props => {
  const {
    change,
    error,
    form,
    handleSubmit,
    hasResults,
    highlightedRows,
  } = props

  return (
    <form
      className={'path-database-search-form heading-font'}
      id={form}
      onSubmit={handleSubmit}>
      <div className={'bg-white'}>
        <SubmitErrors
          error={error}
          idRoot={form}
          sourceForm={form} />
      </div>
      <Search
        change={change}
        hasResults={hasResults}
        highlightedRows={highlightedRows}
        idRoot={`${form}-`}
        sourceForm={form} />
      <Pagination
        idRoot={`${form}-`}
        sourceForm={form} />
    </form>
  )
}

Form.propTypes = {
  change: func.isRequired,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  hasResults: bool.isRequired,
  highlightedRows: array.isRequired,
  error: string,
}

const validate = values => {
  const err = {}
  if (!values.createUserId || !values.createUserId.userId) {
    err.createUserId = REQUIRED
  }
  return err
}

export default reduxForm({
  validate,
})(Form)
